import { Grid, Slider } from '@material-ui/core'
import { AddCircle, Delete } from '@material-ui/icons'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import { theme } from 'config/constants/theme/theme'
export const RatingSlider = withStyles({
  root: {
    color: '#F26723',
    backgroundColor: '#C3C3C3',
    height: 6,
    padding: 0,
    margin: '.2rem 0',
    borderRadius: 4,
    '&.Mui-disabled': {
      color: '#F26723',
      backgroundColor: '#C3C3C3',
      height: 6
    },
    [theme.breakpoints.down('md')]: {
      height: 8
    }
  },
  thumb: {
    height: 12,
    width: 12,
    backgroundColor: '#369adc',
    marginTop: -3,
    marginLeft: -5,
    '&:focus,&:hover,&$active': {
      boxShadow: 'inherit'
    },
    '&.Mui-disabled': {
      visibility: 'hidden'
    }
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)'
  },
  track: {
    height: 6,
    borderRadius: 4
  },
  rail: {
    height: 6,
    backgroundColor: '#C3C3C3',
    borderRadius: 4
  },
  mark: {
    backgroundColor: '#979797',
    height: 6,
    [theme.breakpoints.down('md')]: {
      height: 8
    }
  }
})(Slider)

const styleConfig = {
  root: {
    color: '#7747b2',
    cursor: 'pointer',
    marginTop: '.3rem'
  }
}
export const DeleteIcon = withStyles(styleConfig)(Delete)

export const AddCircleIcon = withStyles(styleConfig)(AddCircle)

export const Container = withStyles({
  root: {
    padding: '.5rem',
    minHeight: '168px',
    '&:hover': {
      backgroundColor: '#f0eeee',
      borderRadius: 12,
      cursor: 'pointer'
    },
    [theme.breakpoints.down('md')]: {
      padding: 0
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: '110px'
    }
  }
})(Grid)

export default makeStyles({
  labelTitle: { color: '#64CCE9', fontSize: '14px' },
  header: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    margin: '0 0 1rem 1rem',
    [theme.breakpoints.down('sm')]: {
      margin: '0.5rem 0 1rem 0'
    }
  },
  error: {
    fontSize: '12px',
    color: '#ba0800'
  },
  headerKnowledge: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    margin: '1rem 0 1rem 1rem',
    [theme.breakpoints.down('sm')]: {
      margin: '1rem 0 1rem 0'
    }
  },
  balloon: {
    marginTop: '1.2rem'
  },
  ratingContainer: {
    paddingLeft: '1.1rem',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0
    }
  },
  gridContainer: {
    [theme.breakpoints.down('md')]: {
      padding: '5px 15px 10px'
    }
  },
  title: {
    fontSize: '28px',
    color: '#7647b2',
    [theme.breakpoints.down('sm')]: {
      fontSize: '20px',
      fontWeight: 300
    }
  },
  hide: {
    visibility: 'hidden'
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '.2rem'
  },
  gridExpertise: {
    paddingTop: '0 !important'
  },
  expertise: {
    fontSize: '12px',
    width: 113,
    color: '#6C6471'
  },
  paragraph: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  definedCategory: {
    fontSize: '15px'
  },
  marksEmpty: {
    '& :nth-child(4)': {
      display: 'none'
    },
    '& :nth-child(6)': {
      display: 'block',
      width: '1px'
    },
    '& :nth-child(8)': {
      display: 'block',
      width: '1px'
    },
    '& :nth-child(10)': {
      display: 'block',
      width: '1px'
    },
    '& :nth-child(12)': {
      display: 'none'
    }
  },
  marksLevelThree: {
    '& :nth-child(4)': {
      display: 'none'
    },
    '& :nth-child(6)': {
      display: 'none',
      width: '1px'
    },
    '& :nth-child(8)': {
      display: 'none',
      width: '1px'
    },
    '& :nth-child(10)': {
      display: 'block',
      width: '1px'
    },
    '& :nth-child(12)': {
      display: 'none'
    }
  },
  marksFull: {
    '& :nth-child(4)': {
      display: 'none'
    },
    '& :nth-child(6)': {
      display: 'none',
      width: '1px'
    },
    '& :nth-child(8)': {
      display: 'none',
      width: '1px'
    },
    '& :nth-child(10)': {
      display: 'none',
      width: '1px'
    },
    '& :nth-child(12)': {
      display: 'none'
    }
  },
  floatRight: {
    float: 'right'
  }
})
